export type StorageErrorCode
  = | 'NOT_FOUND'
    | 'INVALID_INPUT'
    | 'BUILTIN_READONLY'
    | 'DB_FAILURE'

export class StorageError extends Error {
  readonly code: StorageErrorCode

  constructor(code: StorageErrorCode, message: string, options?: { cause?: unknown }) {
    super(message, options)
    this.name = 'StorageError'
    this.code = code
  }
}

export function isStorageError(e: unknown): e is StorageError {
  return e instanceof StorageError
}
